import { path, createCachedSelector, defaultKeySelector } from '@cbridge-utils/redux';
import { RuleStatus } from '@cbridge-tools/rules-data-grid';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { rulesManagementStoreSelector } from '../rulesManagement.selector';

export const rulesActiveSelector = createCachedSelector(
  [
    path(rulesManagementStoreSelector).rules(),
  ],
  (rules) => {
    return (rules ?? []).filter((rule) => rule.status !== RuleStatus.Deleted);
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: defaultKeySelector,
});
